import React, { useState, useEffect, useRef } from 'react';
import { loaderStateTrue, loaderStateFalse, userSearchData, priceDistributionResponseData, priceDistributionRequestData, trendingDestination, selectChooseBranch } from '../../../../Actions/AllAction';
import { setUserCredentials } from '../../../../GlobalModules/Login/Actions/LoginAction';
import { connect } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';
import '../../../../Utility/Public/css/common.scss';
import '../../Payment/Assets/css/paymentdoc.scss';
import '../../Payment/Assets/css/paymentresponsivedoc.scss';
import PartialPaymentModal from '../../../../Utility/Components/PaymentModal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import ErrorBoundary from 'antd/es/alert/ErrorBoundary';
import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Utility from '../../../../Utility/Utility';
import FancyBoxImage from '../../../../Utility/Components/FancyBoxImage';
import ModalGlobal from '../../../../Utility/Components/ModalGlobal';
import { paymentPriceDistribution, hotelRoomTypesSearchList } from '../Controller/HomeController'
import { redirectToAuth } from '../../../../Utility/helpers/authRedirect';
import PaymentDetailsModalContent from '../Components/PaymentDetailsModalContent'
import moment from 'moment';
import Select, { components } from "react-select";
import Tooltip from 'react-bootstrap/Tooltip';
import GuestCheckOutModalContent from '../Components/GuestCheckOutModalContent';
import HotelBooking from '../Components/HotelBooking';
import BreadcrumbMenu from '../../../../Utility/Components/BreadcrumbMenu'
import LazyImage from '../../../../Utility/Components/LazyImageComponent';
import { customerWorkStatus } from '../../../../Utility/Controller/UtilityController';
import RoomTypeDetailsModalContent from '../Components/RoomTypeDetailsModalContent'
import '../Assets/css/VariantDetailsDoc.scss'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SearchPanel from '../Components/SearchPanel';
import { useParams } from 'react-router-dom';
import { serachDataFormatingFn } from '../Model/HomeModel';
import Accordion from 'react-bootstrap/Accordion';
function HotelDetails(props) {
    const params = useParams();
    const [slug, setSlug] = useState(params.slug);
    const [bookingDetailsObj, setBookingDetailsObj] = useState({});
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [userDetailsData, setUserDetailsData] = useState({})
    const [selectedRoom, setSelectedRoom] = useState(props.userSearchDataFromReducer?.selectedRoom && Object.keys(props.userSearchDataFromReducer.selectedRoom).length > 0 ? props.userSearchDataFromReducer.selectedRoom : {})
    const [fancyBoxModal, setFancyBoxModal] = useState(false);
    const [fancyBoxSelectedImg, setFancyBoxSelectedImg] = useState("");
    const [paymentDetailsData, setPaymentDetailsData] = useState({});
    const [paymentDetailsModalFlag, setPaymentDetailsModalFlag] = useState(false);
    const [guestCheckOutModalFlag, setGuestCheckOutModalFlag] = useState(false);
    const [isGuestFlag, setIsGuestFlag] = useState(false);
    const [guestDetailsData, setGuestDetails] = useState({});
    const [showFull, setShowFull] = useState(false);
    const [roomTypeDetailsModalFlag, setRoomTypeDetailsModalFlag] = useState(false);
    const [roomTypeDetailsData, setRoomTypeDetailsData] = useState({});
    const [roomBookFormData, setRoomBookFormData] = useState({
        "start_date": "",
        "end_date": "",
        "branch_id": "",
        "adults": 1,
        "children": 0,
        "rooms": 1,
        "location": ""
    })
    const [hotelRoomBookDataSet, setHotelRoomBookDataSet] = useState([])
    const history = useHistory();

    const options1 = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' }
    ]
    const [selectedVariantsByRoomType, setSelectedVariantsByRoomType] = useState({});
    const [branchLocationData, setBranchLocationData] = useState("");
    const [branchLocationModalFlag, setBranchLocationModalFlag] = useState(false);
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const slider1 = useRef(null);
    const slider2 = useRef(null);
    const [searchResult, setsearchResult] = useState([]);
    const [apiCallFinish, setApiCallFinish] = useState(false)
    const [overlay, setOverlay] = useState(true)
    const [isMobileView, setIsMobileView] = useState(false);
    const [activeAccordion, setActiveAccordion] = useState("0");
    const [roomFacilitiesPopupDialogFlag, setRoomFacilitiesPopupDialogFlag] = useState(false);
    const [branchFacilitiesPopupDialogFlag, setBranchFacilitiesPopupDialogFlag] = useState(false);
    const [roomFacilitiesPopupData, setRoomFacilitiesPopupData] = useState([]);
    const [hotelBookingModalFlag, setHotelBookingModalFlag] = useState(false);

    useEffect(() => {
        setNav1(slider1.current);
        setNav2(slider2.current);
    }, [slider1, slider2]);

    const getBranchImageList = (branchData) => {
        const fallback = [require("../../../../Utility/Public/images/no-icon1.png")];
        if (!branchData) return fallback;

        try {
            const allImages = Array.isArray(branchData.branch_all_images) ? branchData.branch_all_images : [];
            const propertyPhotos = allImages.filter(img =>
                img.asset_category === "PROPERTY" && img.asset_type === "PHOTO"
            );

            const extractUrls = (source) => {
                if (!source) return [];
                let imageUrl = source.image_url !== undefined ? source.image_url : source;

                if (typeof imageUrl === 'string') {
                    try {
                        imageUrl = JSON.parse(imageUrl);
                    } catch (e) {
                        // plain string URL
                    }
                }

                if (Array.isArray(imageUrl) && imageUrl.length > 0) {
                    return imageUrl.map(img => {
                        if (typeof img === 'string') return img;
                        return img?.file_url || img?.img_url || img?.image_url;
                    }).filter(url => url && url !== '');
                }

                if (typeof imageUrl === 'object' && imageUrl !== null) {
                    const url = imageUrl.file_url || imageUrl.img_url || imageUrl.image_url;
                    if (url) return [url];
                }

                if (typeof imageUrl === 'string' && imageUrl.trim() !== '') {
                    return [imageUrl];
                }

                return [];
            };

            if (propertyPhotos.length > 0) {
                const urls = propertyPhotos.flatMap(extractUrls).filter(url => url && url !== '');
                if (urls.length > 0) return urls;
            }

            if (branchData.branch_images) {
                const urls = extractUrls(branchData.branch_images).filter(url => url && url !== '');
                if (urls.length > 0) return urls;
            }
        } catch (error) {
            console.error("Error parsing branch images:", error);
        }

        return fallback;
    };

    const images = getBranchImageList(props.selected_branch);
    const [exploreSlideOption, setExploreSlideOption] = useState({
        loop: false,
        autoplay: true,
        nav: false,
        margin: 0,
        dots: true,
        responsive: {
            0: {
                items: 1,
            },
            481: {
                items: 2,
            },
            768: {
                items: 3,
            },
            1000: {
                items: 5,
            },
        },
    });

    const [fancyimageList, setfancyimageList] = useState([])

    //check user logged in or not
    useEffect(() => {
        // Check both Redux state and localStorage token to avoid redirect loops
        const hasToken = localStorage.getItem('token') || localStorage.getItem('accessToken');
        if (!props.isLoggedIn && !hasToken) {
            const currentPath = props.location.pathname;
            const searchParams = new URLSearchParams(props.location.search);
            const language = localStorage.getItem('i18nextLng') || 'en';
            // Use redirectToAuth to preserve URL and parameters
            // redirectToAuth(props.history, currentPath, searchParams, 'login', language);
        } else {
            sessionStorage.setItem('previousUrl', `/${localStorage.getItem('i18nextLng')}/hotel-details`)
        }
    }, [props.isLoggedIn, props.location, props.history]);

    //if no branch selected then redirct to home tab
    // useEffect(() => {
    //     const searchData = Utility.decodeUrlParams(history.location.search);
    //     if (!["destination", "start_date", "end_date", "adult"].some(key => searchData.hasOwnProperty(key) && searchData[key])) {
    //         history.push(`/${localStorage.getItem('i18nextLng')}/home`);
    //     }
    // }, [])
    useEffect(() => {
        if (slug) {
            setOverlay(true);
            const searchData = Utility.decodeUrlParams(history.location.search);
            let data = { ...searchData };
            if (!data.start_date) {
                data.start_date = moment().format("YYYY-MM-DD");
            }
            if (!data.end_date) {
                data.end_date = moment(data.start_date, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD");
            }
            if (!data.adult) {
                data.adult = 1;
            }
            const formattedData = serachDataFormatingFn(data);
            if (typeof slug === "string") {
                formattedData["slug"] = slug
            }
            else if (typeof slug === "number") {
                formattedData["branch_id"] = slug
            }
            hotelRoomTypesSearchList(formattedData).then(async (response) => {
                if (response.success) {
                    if (response.success) {
                        let newDataSet = await formatingSearchData(response.data);
                        // newDataSet = newDataSet.filter((item) => item.branch_id == slug);
                        let branchData = newDataSet[0];
                        // console.log("branchData", branchData)
                        const branchCity = branchData?.branch_full_details?.city || branchData?.hotel_details?.city || branchData?.city || '';
                        const branchState = branchData?.branch_full_details?.state || branchData?.hotel_details?.state || branchData?.state || '';
                        const currentDest = searchData.destination || branchCity || branchState || '';

                        let searchDataForUrl = {};
                        searchDataForUrl['adults'] = formattedData.adult;
                        searchDataForUrl['child'] = formattedData.childs.length;
                        searchDataForUrl['start_date'] = moment(formattedData.startDate).format('YYYY-MM-DD');
                        searchDataForUrl['end_date'] = moment(formattedData.endDate).format('YYYY-MM-DD');
                        if (currentDest) {
                            searchDataForUrl['destination'] = currentDest;
                        }
                        props.selectChooseBranch({ ...branchData, ...searchDataForUrl });

                        if (currentDest) {
                            let reducerSearch = props.userSearchDataFromReducer || {};
                            props.userSearchData({
                                ...reducerSearch,
                                destination: currentDest,
                                start_date: searchData.start_date || formattedData.startDate || reducerSearch.start_date,
                                end_date: searchData.end_date || formattedData.endDate || reducerSearch.end_date,
                                adult: formattedData.adult || reducerSearch.adult || 1,
                                children: formattedData.childs ? formattedData.childs.length : (reducerSearch.children || 0),
                            });
                        }

                        if (!searchData.start_date && !searchData.end_date) {
                            console.log("Updating the url...")
                            searchDataForUrl['destination'] = currentDest || formattedData.destination;
                            searchDataForUrl['adult'] = formattedData.adult;
                            const queryParams = Utility.buildUrlParams(searchDataForUrl);
                            const currentPath = history.location.pathname;
                            history.replace(`${currentPath}?${queryParams}`);
                        }

                        // setsearchResult(newDataSet)
                        setTimeout(() => {
                            setOverlay(false)
                        }, 500);
                    }
                } else {
                    Utility.toastNotifications("Data not found", "Warning", "warning");
                }
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                    // history.push(`/${localStorage.getItem('i18nextLng')}/home`);
                }
            })
        } else {
            history.push(`/${localStorage.getItem('i18nextLng')}/home`);
        }
    }, [slug, history])
    const formatingSearchData = async (data) => {
        let branchArray = [];
        if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                for (let b = 0; b < data[i].branch_details.length; b++) {
                    let newKeydata = data[i].branch_details[b];
                    newKeydata["hotel_details"] = data[i].hotel_details
                    branchArray.push(newKeydata)
                }
            }
        }
        return branchArray;
    }
    //visitor count will update 
    useEffect(() => {
        if (props.isLoggedIn) {
            if (props.selected_branch?.branch_id != undefined && props.selected_branch?.branch_id != null) {
                let dataset = {
                    [props.selected_branch?.branch_id]:
                    {
                        type: "visited"
                    }
                }
                customerWorkStatus(dataset);
            }
        }
    }, [props.isLoggedIn, props.selected_branch])

    //after selecting room , data will store on redux
    useEffect(() => {
        if (selectedRoom) {
            let reducerData = props.userSearchDataFromReducer;
            let tempSearchData = { ...reducerData, "selectedRoom": selectedRoom }
            props.userSearchData(tempSearchData)
        }
    }, [selectedRoom])

    const closePaymentModal = () => {
        setShowPaymentModal(false);
    }

    const selectRoomOptionListGenerateFn = (value, variant) => {
        const totalAvailableRooms = value.total_available_rooms; // e.g., 10

        const roomTypeId = value.id;

        // Calculate total rooms selected for this room type across all variants
        let totalSelectedForRoomType = 0;
        if (selectedRoom[roomTypeId]) {
            totalSelectedForRoomType = Object.values(selectedRoom[roomTypeId]).reduce((acc, curr) => {
                return acc + (curr?.value ? Number(curr.value) : 0);
            }, 0);
        }

        // Calculate current variant's selected count
        const currentVariantSelected = selectedRoom[roomTypeId]?.[variant.variant_id]?.value
            ? Number(selectedRoom[roomTypeId][variant.variant_id].value)
            : 0;

        // Calculate remaining rooms
        const remainingRooms = totalAvailableRooms - (totalSelectedForRoomType - currentVariantSelected);

        // Prevent negative or zero
        const availableOptions = Math.max(remainingRooms, 0);

        const options = [];
        for (let i = 1; i <= availableOptions; i++) {
            options.push({
                value: i,
                label: `${i} ${i === 1 ? 'Room' : 'Rooms'}`
            });
        }

        return options;
    };

    //room count selection onchange fn
    /*const handelChange = (e, idx, value, variant = null) => {
        if (e) {
            e["price_today"] = value.price_today;
            e["total_room_price"] = Number(e.value) * Number(value.price_today);
            e["room_type_name"] = value.room_type;
            e["room_type_id"] = value.id;
            e["currency"] = props.selected_branch?.currency;
            e["start_date"] = props.selected_branch?.start_date;
            e["end_date"] = props.selected_branch?.end_date;
            e["num_of_adult_max"] = value.num_of_adult_max;
            e["num_of_child_max"] = value.num_of_child_max;
            e["variant_code"] = variant.code;
            e["variant_id"] = variant.variant_id;

            setSelectedRoom(prevObject => ({
                ...prevObject,
                [idx]: e,
            }));


        } else {
            setSelectedRoom(prevObject => {
                const updatedObject = { ...prevObject };
                delete updatedObject[idx];
                return updatedObject;
            });
        }
    }*/
    const handelChange = (e, idx, value, variant) => {

        if (e) {
            const currentSelection = Number(e.value);
            let totalSelected = 0;
            if (selectedRoom[value.id] && selectedRoom[value.id][variant.variant_id]) {
                totalSelected = Number(selectedRoom[value.id][variant.variant_id].value || 0);
            }
            const updatedTotal = currentSelection;

            if (updatedTotal > value.total_available_rooms) {
                Utility.toastNotifications(`Cannot select ${currentSelection} rooms. Only ${value.total_available_rooms} available for this variant in this room type.`, "Warning", "warning");
                return;
            }

            const updatedData = {
                ...e,
                // price_today: value.price_today,
                price_today: variant.total_price,
                // total_room_price: currentSelection * Number(value.price_today),
                total_room_price: currentSelection * Number(variant.total_price),
                room_type_name: value.room_type,
                room_type_id: value.id,
                currency: props.selected_branch?.currency,
                start_date: props.selected_branch?.start_date,
                end_date: props.selected_branch?.end_date,
                num_of_adult_max: variant.max_adults || 0,
                num_of_child_max: variant.max_children || 0,
                variant_code: variant.code,
                variant_id: variant.variant_id,
                room_type_variant_rel_id: variant.room_type_variant_rel_id,
            };

            setSelectedRoom(prev => ({
                ...prev,
                [value.id]: {
                    ...prev[value.id],
                    [variant.variant_id]: updatedData
                }
            }));

        } else {
            // Handle clearing
            setSelectedRoom(prev => {
                const updated = { ...prev };
                if (updated[value.id]) {
                    delete updated[value.id][variant.variant_id];
                    if (Object.keys(updated[value.id]).length === 0) {
                        delete updated[value.id];
                    }
                }
                return updated;
            });
        }
    };

    const handleCardCheckToggle = (e, variant, vIdx, roomTypeId) => {
        e.stopPropagation();
        const isChecked = e.target.checked ?? !variant.checked;
        variant.checked = isChecked;
        // Update selectedVariantsByRoomType
        setSelectedVariantsByRoomType((prev) => {
            const prevList = prev[roomTypeId] ?? [];
            let updatedList;

            if (isChecked) {
                if (!prevList.includes(variant.variant_id)) {
                    updatedList = [...prevList, variant.variant_id];
                } else {
                    updatedList = prevList;
                }
                return {
                    ...prev,
                    [roomTypeId]: updatedList,
                };
            } else {
                updatedList = prevList.filter((id) => id !== variant.variant_id);

                if (updatedList.length === 0) {
                    const updated = { ...prev };
                    delete updated[roomTypeId];
                    return updated;
                } else {
                    return {
                        ...prev,
                        [roomTypeId]: updatedList,
                    };
                }
            }
        });
        if (!isChecked) {
            setSelectedRoom((prev) => {
                const updatedRoomType = { ...(prev[roomTypeId] ?? {}) };
                delete updatedRoomType[variant.variant_id];
                if (Object.keys(updatedRoomType).length === 0) {
                    const updated = { ...prev };
                    delete updated[roomTypeId];
                    return updated;
                } else {
                    return {
                        ...prev,
                        [roomTypeId]: updatedRoomType,
                    };
                }
            });
        }
    };


    //room type image show modal fn
    const fancyBoxModalFN = (e, img, imageArry = []) => {
        let imageList = [];
        setFancyBoxModal(true);
        setFancyBoxSelectedImg(img);
        if (imageArry.length > 0) {
            imageList = imageArry.map((value) => JSON.parse(value.image_url).img_url)
        }
        setfancyimageList(imageList)
    };

    //room type image close modal fn
    const closefancyBoxModal = () => {
        setFancyBoxModal(false);
    };

    const renderMealStatus = (label, isIncluded, rate) => {
        //console.log('rate=========', rate)
        if (!isIncluded) return null;
        return <div><span style={{ color: 'green' }}>●</span> <strong>{label} {rate > 0 ? "" : <span style={{ color: 'green' }}>Free</span>}</strong> {rate > 0 ? <><span style={{ color: 'green' }}>●</span> {Utility.getCurrencySymbol(props.selected_branch?.currency)} {Number(rate).toFixed(0)}</> : ""}</div>;
    };

    const roomTypeDetailsFn = (data, index) => {
        setRoomTypeDetailsData(data)
        setRoomTypeDetailsModalFlag(true)
    }

    const branchWiseAmenityUi = () => {
        const { selected_branch } = props;
        let array = [];
        if (Object.keys(selected_branch).length > 0 && selected_branch?.branch_wise_amenity) {
            const sortedArray = [...selected_branch?.branch_wise_amenity];
            if (selected_branch && sortedArray && sortedArray.length > 0) {
                sortedArray.map((value, idx) => {
                    array.push(
                        <div key={idx} className='amenity-box-sec'>
                            <ul>
                                <li>
                                    <span>
                                        <LazyImage
                                            src={value?.logo_url && value?.logo_url != "" ? JSON.parse(value?.logo_url).img_url : require('../../../../Utility/Public/images/no-icon1.png')}
                                            alt={require('../../../../Utility/Public/images/no-icon1.png')}
                                            loaderImage={require('../../../../Utility/Public/images/no-icon1.png')}
                                            className={"facilityIcon"}
                                        />
                                        {value?.amenity_name}
                                    </span>
                                </li></ul>
                        </div>
                    )

                })
            }

        }
        return array;
    }

    const handelRoomInput = (count, roomTypeData, rateData) => {
        const roomTypeId = roomTypeData.id;
        const rateId = rateData.id;
        const countNum = Math.max(0, parseInt(count) || 0);
        if (countNum === 0) {
            setSelectedRoom(prev => {
                const updated = { ...prev };
                if (updated[roomTypeId]) {
                    delete updated[roomTypeId][rateId];
                    if (Object.keys(updated[roomTypeId]).length === 0) {
                        delete updated[roomTypeId];
                    }
                }
                return updated;
            });
        } else {
            setSelectedRoom(prev => ({
                ...prev,
                [roomTypeId]: {
                    ...(prev[roomTypeId] || {}),
                    [rateId]: {
                        value: countNum,
                        room_type_name: roomTypeData.room_type_name,
                        room_type_id: roomTypeId,
                        currency: props.selected_branch?.currency,
                        start_date: props.selected_branch?.start_date,
                        end_date: props.selected_branch?.end_date,
                        num_of_adult_max: roomTypeData.max_adults || 0,
                        num_of_child_max: roomTypeData.max_children || 0,
                        base_adults: roomTypeData.base_adults || 0,
                        base_children: roomTypeData.base_children || 0,
                        room_type_variant_rel_id: rateId,
                        price_today: rateData.selling_rate_per_night,
                        total_room_price: countNum * Number(rateData.selling_rate_per_night),
                        rate_plan: rateData.MealPlanData?.plan_name || 'Room Only',
                    }
                }
            }));
        }
    };

    //room type details ui
    const roomTypeUi = () => {
        const { selected_branch } = props;
        let array = [];
        if (Object.keys(selected_branch).length > 0 && selected_branch?.roomtype_details?.length > 0) {
            const sortedArray = [...selected_branch?.roomtype_details];
            if (selected_branch && sortedArray && sortedArray.length > 0) {
                sortedArray.map((value, idx) => {
                    let roomImage = "";
                    const allImages = selected_branch?.branch_all_images || [];
                    const roomImages = allImages.filter(img => img.room_type_id === value.id);
                    if (roomImages.length > 0) {
                        try {
                            const parsed = JSON.parse(roomImages[0].image_url);
                            roomImage = Array.isArray(parsed) ? parsed[0]?.file_url : parsed?.file_url || "";
                        } catch (e) { roomImage = ""; }
                    }
                    array.push(
                        <div className='room-details-section-box' key={idx}>
                            <div className='room-type-box'>
                                {/* {roomImage &&
                                    <div className='room-type-image-box'>
                                        <img src={roomImage} alt={value.room_type_name} className='room-type-img' style={{ width: '100%', maxHeight: '180px', objectFit: 'cover', borderRadius: '6px', marginBottom: '10px' }} />
                                    </div>
                                } */}
                                <div className='mediaBoxes'>
                                    <div className='mediaBoxLeftSide'>
                                        <div className="media room-type-image">
                                            <div className="media-body">
                                                <h5 className="mt-0 room-image-not-available">{value.room_type_name}</h5>
                                                {selected_branch?.cancellationRule && selected_branch.cancellationRule.length === 0 &&
                                                    <p className='label-suc'>Free cancellation</p>
                                                }
                                            </div>
                                        </div>
                                        {Object.keys(value).length > 0 &&
                                            <div className='roomtypeDetailsBox'>
                                                {value.description && value.description !== "" &&
                                                    <p>{value.description.length >= 180 ?
                                                        <OverlayTrigger overlay={<Tooltip className="largeTooltipBox">{value.description}</Tooltip>}>
                                                            <span>{value.description.substring(0, 177) + "..."}</span>
                                                        </OverlayTrigger> :
                                                        <span>{value.description}</span>
                                                    }</p>
                                                }
                                                <ul>
                                                    {value.bed_type && <li>Bed Type - {value.bed_type}</li>}
                                                    {value.bed_count && Number(value.bed_count) !== 0 && <li>Number of Beds - {value.bed_count}</li>}
                                                    {value.ac_type && <li>AC - {value.ac_type}</li>}
                                                    {value.max_adults > 0 && <li>Max Adults - {value.max_adults}</li>}
                                                    {value.max_children > 0 && <li>Max Children - {value.max_children}</li>}
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className='room-type-details-container'>
                                    <div className="room-variant-details">
                                        <div className='room-type-variant-box room-type-variant-box-header'>
                                            <div className='today-price-box'>Price / Night</div>
                                            <div className='variant-box'>Meal Plan</div>
                                            <div className='select-room-box'>Rooms</div>
                                        </div>
                                        {value.RoomRates && value.RoomRates.length > 0 ?
                                            value.RoomRates.map((rate, rIdx) => {
                                                const currentCount = selectedRoom[value.id]?.[rate.id]?.value || 0;
                                                return (
                                                    <div className="variant-details-inner-box" key={rIdx}>
                                                        <div className='today-price-box'>
                                                            <p className="meal-details">
                                                                <span className='base-price'>
                                                                    {Utility.getCurrencySymbol(rate.currency || props.selected_branch?.currency)} {Number(rate.selling_rate_per_night).toFixed(0)}
                                                                </span> 
                                                                <span style={{ fontSize: '0.8em', color: '#666' }}>per night</span>
                                                            </p>
                                                        </div>
                                                        <div className='variant-box'>
                                                            <div className="card-body">
                                                                {rate.MealPlanData && rate.MealPlanData.plan_name &&
                                                                    <div className='comp-name'>
                                                                        <span className='highlights-svg'>
                                                                            <svg className="bk-icon -streamline-checkmark_fill" fill="#008009" height="14" width="14" viewBox="0 0 128 128" role="presentation" aria-hidden="true" focusable="false"><path d="M56.33 102a6 6 0 0 1-4.24-1.75L19.27 67.54A6.014 6.014 0 1 1 27.74 59l27.94 27.88 44-58.49a6 6 0 1 1 9.58 7.22l-48.17 64a5.998 5.998 0 0 1-4.34 2.39z"></path></svg>
                                                                        </span>
                                                                        {rate.MealPlanData.plan_name}
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className='select-room-box'>
                                                            <div className="room-details">
                                                                <div className="room-count-input-box" onClick={(e) => e.stopPropagation()}>
                                                                    <button
                                                                        className="room-count-btn"
                                                                        onClick={() => handelRoomInput(currentCount - 1, value, rate)}
                                                                        disabled={currentCount <= 0}
                                                                    >-</button>
                                                                    <input
                                                                        type="number"
                                                                        min="0"
                                                                        className="room-count-input"
                                                                        value={currentCount}
                                                                        onChange={(e) => handelRoomInput(e.target.value, value, rate)}
                                                                    />
                                                                    <button
                                                                        className="room-count-btn"
                                                                        onClick={() => handelRoomInput(currentCount + 1, value, rate)}
                                                                    >+</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                            :
                                            value.price &&
                                            <div className="variant-details-inner-box">
                                                <div className='today-price-box'>
                                                    <p className="meal-details">
                                                        <span className='base-price'>
                                                            {Utility.getCurrencySymbol(value.currency || props.selected_branch?.currency)} {Number(value.price).toFixed(0)}
                                                        </span>
                                                        <span style={{ fontSize: '0.8em', color: '#666' }}>per night</span>
                                                    </p>
                                                </div>
                                                <div className='variant-box'></div>
                                                <div className='select-room-box'>
                                                    <div className="room-details">
                                                        <div className="room-count-input-box" onClick={(e) => e.stopPropagation()}>
                                                            <button
                                                                className="room-count-btn"
                                                                onClick={() => handelRoomInput((selectedRoom[value.id]?.[value.id]?.value || 0) - 1, value, { id: value.id, selling_rate_per_night: value.price })}
                                                                disabled={(selectedRoom[value.id]?.[value.id]?.value || 0) <= 0}
                                                            >-</button>
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                className="room-count-input"
                                                                value={selectedRoom[value.id]?.[value.id]?.value || 0}
                                                                onChange={(e) => handelRoomInput(e.target.value, value, { id: value.id, selling_rate_per_night: value.price })}
                                                            />
                                                            <button
                                                                className="room-count-btn"
                                                                onClick={() => handelRoomInput((selectedRoom[value.id]?.[value.id]?.value || 0) + 1, value, { id: value.id, selling_rate_per_night: value.price })}
                                                            >+</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })
            }
        }
        return array;
    }

    //proceed to booking debounce onclick fn 
    const openProceedPriceDistributionPage = Utility.debounceButton(async () => {
        const { userSearchDataFromReducer, selected_branch, userCredentials } = props;
        setIsGuestFlag(false)
        let vaildData = validationRoomBookFromData();
        if (vaildData) {
            if (Object.keys(userCredentials).length > 0) {
                await hotelRoomBookedDataSave();
            } else {
                const currentPath = props.location.pathname;
                const searchParams = new URLSearchParams(props.location.search);
                const language = localStorage.getItem('i18nextLng') || 'en';
                // Use redirectToAuth to preserve URL and parameters
                // redirectToAuth(props.history, currentPath, searchParams, 'login', language);
                // props.history.push(`/${localStorage.getItem('i18nextLng')}/login/property-details`);
            }
        }
    }, 300)

    //booking price distribution dataset validation
    const validationRoomBookFromData = () => {
        const { userSearchDataFromReducer } = props;
        let valid = true;
        let totalAdultRoomNeeded = 0
        let totalChildRoomNeeded = 0
        let totalAdultAndChild = 0
        let maxAdults = 0;
        let minAdult = 0;

        if (Object.keys(userSearchDataFromReducer.selectedRoom).length > 0) {
            let selectedRoomData = userSearchDataFromReducer.selectedRoom ? userSearchDataFromReducer.selectedRoom : {}
            Object.values(selectedRoomData).map((roomData, index) => {
                Object.values(roomData).map((roomVal, idx) => {
                    maxAdults += Number(roomVal.num_of_adult_max) * Number(roomVal.value);
                    minAdult += Number(roomVal.value);
                    let roomAdultMulti = Number(roomVal.num_of_adult_max) * Number(roomVal.value)
                    totalAdultRoomNeeded += Number(roomAdultMulti)
                    let roomChildMulti = Number(roomVal.num_of_child_max) * Number(roomVal.value)
                    totalChildRoomNeeded += Number(roomChildMulti)
                    totalAdultAndChild += Number(roomVal.num_of_adult_max + roomVal.num_of_child_max) * Number(roomVal.value)
                })
            })
        }

        let totalPersent = Number(userSearchDataFromReducer.adult) + Number(userSearchDataFromReducer.children);
        let numAdults = userSearchDataFromReducer.adult;
        let numAdultsGreaterMaxAdults = false
        // if (Number(numAdults) > Number(maxAdults)) {
        //     valid = false
        //     Utility.toastNotifications("Total number of adults exceeds the maximum allowed.", "Warning", "warning")
        //     numAdultsGreaterMaxAdults = true;
        //     return false;
        // } 
        // else if (minAdult > numAdults) {
        //     valid = false
        //     Utility.toastNotifications("You have selected more rooms than your adults count.", "Warning", "warning")
        //     return false;
        // }
        // if (!numAdultsGreaterMaxAdults) {
        //     if (totalAdultRoomNeeded <= totalPersent) {
        //         if (numAdults > 0) {
        //             if (totalAdultRoomNeeded < numAdults) {
        //                 valid = false
        //                 Utility.toastNotifications("Total number of adults exceeds the maximum allowed.", "Warning", "warning");
        //                 return false;
        //             }
        //             if (totalPersent <= totalAdultAndChild) {
        //             } else {
        //                 valid = false
        //                 Utility.toastNotifications("Total number of adults and children exceeds the maximum allowed.", "Warning", "warning");
        //                 return false;
        //             }
        //         } else {
        //             valid = false
        //             Utility.toastNotifications("No of adults must be greater than 0", "Warning", "warning");
        //             return false;
        //         }
        //     }
        // }
        if (minAdult === 0) {
            valid = false;
            Utility.toastNotifications("Please select at least one room.", "Warning", "warning");
            return false;
        }
        return valid;
    }

    //booking price distribution post api
    async function hotelRoomBookedDataSave() {
        const { loaderStateTrue, loaderStateFalse } = props;
        let vaildData = validationRoomBookFromData();
        if (vaildData) {
            let dataset = formatingHotelBookRoomData();
            setHotelRoomBookDataSet(dataset);
            props.priceDistributionRequestData(dataset);

            dataset = { 'full_journey_details': dataset, }
            // return false
            loaderStateTrue();
            paymentPriceDistribution(dataset).then((response) => {
                loaderStateFalse();
                if (response[0].success) {
                    setPaymentDetailsModalFlag(true)
                    let updatedData = {
                        ...response[0].data[0],
                        is_igst_enable: false,
                    };
                    setPaymentDetailsData(updatedData);
                    props.priceDistributionResponseData(updatedData);
                } else {
                    Utility.toastNotifications("Data Not Found", "Warning", "warning");
                }
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                }
                loaderStateFalse();
                if (error.message == "Network Error") {

                }
            });
        }
    }

    //price disribution post api payload create
    const formatingHotelBookRoomData = () => {
        const { userSearchDataFromReducer, selected_branch } = props;
        function getDatesArray(startDate, endDate) {
            const datesArray = [];
            let currentDate = new Date(startDate);
            while (currentDate <= new Date(endDate)) {
                datesArray.push(new Date(currentDate).toISOString().split('T')[0]);
                currentDate.setDate(currentDate.getDate() + 1);
            }
            return datesArray;
        }

        let date_wise_room_details = getDatesArray(moment(userSearchDataFromReducer.start_date).format("YYYY-MM-DD"), moment(userSearchDataFromReducer.end_date).format("YYYY-MM-DD") + ' 00:00:00');
        let tempHash = {}
        if (date_wise_room_details.length > 0) {
            date_wise_room_details.map((v, i) => {
                let branchIdWiseHash = {};
                let roomData = userSearchDataFromReducer.selectedRoom;
                for (const key in roomData) {
                    if (roomData.hasOwnProperty(key)) {
                        const room = roomData[key];
                        for (const variant in room) {
                            const variantData = room[variant]
                            branchIdWiseHash[variantData.room_type_variant_rel_id] = {
                                "count": variantData.value,
                                "room_id": ""
                            }
                        }
                        tempHash[v] = branchIdWiseHash
                    }
                }

            })
        }

        let agesArr = []
        let child_age = userSearchDataFromReducer.children_age
        if (child_age.length > 0) {
            child_age.map((val, idx) => {
                let agesObj = {}
                agesObj['age'] = val.age.value
                agesArr.push(agesObj)
            })
        }

        let data = [
            {
                "org_id": selected_branch?.branch_wise_booking_rule.org_id,
                "branch_id": selected_branch?.branch_id,
                "book_from": moment(userSearchDataFromReducer?.start_date).format("YYYY-MM-DD"),
                "book_to": moment(userSearchDataFromReducer?.end_date).format("YYYY-MM-DD"),
                "adult": userSearchDataFromReducer.adult,
                "child": JSON.stringify(agesArr),
                "date_wise_food_hash": {

                },
                "date_wise_room_details": tempHash
            }
        ]

        return data;
    }

    //close price distribution modal fn
    const closePaymentDetailsModalFn = () => {
        setPaymentDetailsModalFlag(false)
        setPaymentDetailsData({})
        setGuestDetails({})
    }

    let calculatedDays = 0;
    let calculatedNights = 0;

    if (props.userSearchDataFromReducer) {
        let { days, nights } = Utility.calculateDaysNights(props.userSearchDataFromReducer.start_date, props.userSearchDataFromReducer.end_date);

        calculatedDays = days;
        calculatedNights = nights;

    }

    // checkout as  guest onclick fn 
    const openGuestCheckOutModalFn = Utility.debounceButton(async () => {
        let vaildData = validationRoomBookFromData();
        if (vaildData) {
            setIsGuestFlag(true)
            await hotelRoomBookedDataSave();
        }
    }, 300);

    const openHotelBookingModalFn = Utility.debounceButton(async () => {
        if (roomCountFn(props.userSearchDataFromReducer?.selectedRoom ?? {}) === 0) {
            Utility.toastNotifications("Please select at least one room.", "Warning", "warning");
            return false;
        }
        let vaildData = validationRoomBookFromData();
        if (vaildData) {
            setHotelBookingModalFlag(true)
        }
    }, 300);

    const closeHotelBookingModalFn = () => {
        setHotelBookingModalFlag(false)
    }

    const clearSelectedRoomFn = () => {
        setSelectedRoom({});
        props.userSearchData({ ...props.userSearchDataFromReducer, selectedRoom: {} });
    }

    //close guest modal fn
    const closeGuestCheckOutModalFn = () => {
        setGuestCheckOutModalFlag(false)
    }

    const callBackToHotelDetails = async (guestDetails) => {
        setGuestDetails(guestDetails)
        setGuestCheckOutModalFlag(false)
        await hotelRoomBookedDataSave();
    }

    //bredcrumb home menu click fn
    const homeMenuClick = () => {
        props.history.push(`/${localStorage.getItem('i18nextLng')}/home`);
    }

    const hotelListClick = () => {
        props.history.push(`/${localStorage.getItem('i18nextLng')}/search`);
    }
    const hotelDetailsClick = () => {
        props.history.push(`/${localStorage.getItem('i18nextLng')}/property-details`);
    }
    const bookingListClick = () => {
        props.history.push(`/${localStorage.getItem('i18nextLng')}/booking-history`);
    }

    //Initially fetch bredcrumb menu option
    useEffect(() => {
        breadcrumbUrlFn()
    }, [])

    const breadcrumbUrlFn = () => {
        let breadcrumb = localStorage.getItem('pageArr') ? JSON.parse(localStorage.getItem('pageArr')) : [];
        let newArray = breadcrumb.slice(0, breadcrumb.indexOf('property-details') + 1);
        if (!breadcrumb.includes('property-details')) {
            breadcrumb.push('property-details')
            localStorage.setItem('pageArr', JSON.stringify(breadcrumb));
        } else {
            localStorage.setItem('pageArr', JSON.stringify(newArray));
        }
    }

    //total choosed room count fn
    /*const roomCountFn = (data) => {
        let totalRoomCount = 0;
        Object.keys(data).length > 0 && Object.keys(data).map((key) => {
            if (data[key].value) {
                totalRoomCount += Number(data[key].value)
            }
        })
        return totalRoomCount;
    }*/
    const roomCountFn = (data) => {
        let totalRoomCount = 0;

        Object.keys(data).forEach((roomTypeId) => {
            const variantObj = data[roomTypeId];

            if (variantObj && typeof variantObj === "object") {
                Object.keys(variantObj).forEach((variantId) => {
                    const variantData = variantObj[variantId];
                    if (variantData && variantData.value) {
                        totalRoomCount += Number(variantData.value);
                    }
                });
            }
        });

        return totalRoomCount;
    };

    //checkin checkout time formatting
    const formatTime = (inputTime) => {
        let time = new Date('1970-01-01T' + inputTime);
        let hours = time.getHours();
        let minutes = time.getMinutes();
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        return hours + ':' + minutes;
    }

    //booking details show toogling fn for mobile user
    const toggleShowFull = (type) => {
        if (type === 'mob') {
            setShowFull(!showFull);
        }
    };

    useEffect(() => {
        // console.log("selectedRoom==========", selectedRoom)
        // console.log("selectedVariantsByRoomType==========", selectedVariantsByRoomType)
    }, [selectedRoom, selectedVariantsByRoomType])

    const closeRoomTypeDetailsModal = () => {
        setRoomTypeDetailsData({})
        setRoomTypeDetailsModalFlag(false)
    }

    const showBranchMapFn = (mapLocation) => {
        setBranchLocationData(mapLocation)
        setBranchLocationModalFlag(true)
    }
    const closeBranchMapFn = () => {
        setBranchLocationData("")
        setBranchLocationModalFlag(false)
    }

    //date validation check on hotel search
    const searchDateValidation = () => {
        setsearchResult([]);
        setTimeout(() => {
            setOverlay(false)
        }, 500);
    }

    //hotel branch search api
    const searchHotelBranch = (freshData = null) => {
        const searchParams = freshData || props.userSearchDataFromReducer || {};

        // Only proceed if we have valid destination and dates
        if (!searchParams.destination) {
            console.warn('Search attempted without destination');
            // return;
        }
        const queryParams = Utility.buildUrlParams({ ...searchParams, filterData: {} });
        // Reset any filter parameters to avoid stale filter data
        props.userSearchData({ ...searchParams, filterData: {} });

        // Navigate to search page with parameters
        props.history.push(`/${localStorage.getItem('i18nextLng')}/search?${queryParams}`);
    }

    useEffect(() => {
        setIsMobileView(window.innerWidth < 1024)
    })

    const roomFacilitiesDetailsFn = (data) => {
        setRoomFacilitiesPopupDialogFlag(true)
        setRoomFacilitiesPopupData(data)
    }
    const roomFacilitiesDetailsCloseFn = () => {
        setRoomFacilitiesPopupDialogFlag(false)
        setRoomFacilitiesPopupData([])
    }
    const branchFacilitiesDetailsFn = () => {
        setBranchFacilitiesPopupDialogFlag(true)
    }
    const branchFacilitiesDetailsCloseFn = () => {
        setBranchFacilitiesPopupDialogFlag(false)
    }

    const totalRooms = roomCountFn(props.userSearchDataFromReducer?.selectedRoom ?? {});
    const totalAdults = Number(props.userSearchDataFromReducer.adult ?? 0);
    const totalChildren = Number(props.userSearchDataFromReducer.children ?? 0);
    // console.log("branch_full_details-----------", props.selected_branch.branch_full_details)
    return (
        <div className='hotel-details-container'>
            <div className='searchPanel searchPanelInner'>
                <SearchPanel
                    searchDateValidation={searchDateValidation}
                    callFrom="hotel_details"
                    searchHotelBranch={searchHotelBranch}
                />
            </div>
            <div className='clearfix'></div>
            <div className="booking-details-page hotel-details">
                <div className='breadcrumb-menu'>
                    <div className='container'>
                        <div className='paddingL0'>
                            <BreadcrumbMenu
                                homeMenuDisplay={JSON.parse(localStorage.getItem('pageArr') || '[]').includes('home') ? true : false}
                                hotelListDisplay={JSON.parse(localStorage.getItem('pageArr') || '[]').includes('search') ? true : false}
                                hotelDetailsDisplay={JSON.parse(localStorage.getItem('pageArr') || '[]').includes('hotel-details') ? true : false}
                                bookingListDisplay={JSON.parse(localStorage.getItem('pageArr') || '[]').includes('booking-history') ? true : false}
                                homeMenuClick={homeMenuClick}
                                hotelListClick={hotelListClick}
                                hotelDetailsClick={hotelDetailsClick}
                                bookingListClick={bookingListClick}
                                activeHotelDetails={true}
                            />
                        </div>
                    </div>
                </div>
                <div className='filterBox filterBoxMBottom hotelDetailsTop'>
                    <div className='container'>
                        <div className='leftSectionFilter hotelDetailsTitleBox'>
                            {props.selected_branch && Object.keys(props.selected_branch).length > 0 &&
                                <h2 className='pageTitle'>
                                    {props.selected_branch?.branch_name}
                                    <ul className='destinationName hotelDetailsAddress'>
                                        {props.selected_branch?.branch_full_details?.hasOwnProperty('address1') && props.selected_branch.branch_full_details.address1 &&
                                            <li>
                                                <OverlayTrigger overlay={<Tooltip>Address</Tooltip>}>
                                                    <span ><i className="fa fa-map-marker" aria-hidden="true"></i>
                                                        {props.selected_branch.branch_full_details.address1}
                                                        {props.selected_branch.branch_full_details.hasOwnProperty('address2') && props.selected_branch.branch_full_details.address2 != "" &&
                                                            <>, {props.selected_branch.branch_full_details.address2}</>
                                                        }
                                                        {props.selected_branch.branch_full_details.hasOwnProperty('city') && props.selected_branch.branch_full_details.city != "" &&
                                                            <>, {props.selected_branch.branch_full_details.city}</>
                                                        }
                                                        {props.selected_branch.branch_full_details.hasOwnProperty('state') && props.selected_branch.branch_full_details.state != "" &&
                                                            <>, {props.selected_branch.branch_full_details.state}</>
                                                        }
                                                        {props.selected_branch.branch_full_details.hasOwnProperty('zip') && props.selected_branch.branch_full_details.zip != "" &&
                                                            <>, {props.selected_branch.branch_full_details.zip}</>
                                                        }
                                                    </span>
                                                </OverlayTrigger>
                                            </li>
                                        }
                                        {props.selected_branch?.branch_full_details?.hasOwnProperty('property_type') && props.selected_branch.branch_full_details.property_type &&
                                            <li>
                                                <OverlayTrigger overlay={<Tooltip>Property type</Tooltip>}>
                                                    <span >
                                                        <i className="fa fa-home" aria-hidden="true"></i>
                                                        {props.selected_branch.branch_full_details.property_type}
                                                    </span>
                                                </OverlayTrigger>
                                            </li>
                                        }
                                    </ul>
                                </h2>
                            }
                        </div>
                    </div>
                </div>
                <div className='clearfix'></div>
                <div className='container'>
                    <div className='booking-details-box booking-details-box-variant-wise'>
                        <div className='booking-details-inner'>
                            <div className='row mobRevart'>
                                <div className='col-md-12'>
                                    <div className='row'>
                                        <div className='col-md-9'>
                                            <div className='branch-image-container'>
                                                {images.length > 0 && (
                                                    <div className="col-sm-12 img-caro">
                                                        <Slider
                                                            asNavFor={nav2}
                                                            ref={slider1}
                                                            arrows={false}
                                                            infinite={images.length > 1}
                                                            slidesToShow={1}
                                                            swipeToSlide={true}
                                                            lazyLoad="ondemand"
                                                            className="main-slider"
                                                        >
                                                            {images.map((imageValue, index) => {
                                                                return (
                                                                    <div key={index} className="carousel-main-item">
                                                                        <LazyImage
                                                                            src={imageValue}
                                                                            alt={"room image"}
                                                                            loaderImage={require("../../../../Utility/Public/images/no-icon1.png")}
                                                                            className="carouselImgpic"
                                                                        />
                                                                    </div>
                                                                );
                                                            })}
                                                        </Slider>

                                                        <Slider
                                                            asNavFor={nav1}
                                                            ref={slider2}
                                                            slidesToShow={5}
                                                            swipeToSlide={true}
                                                            focusOnSelect={true}
                                                            arrows={false}
                                                            infinite={images.length > 1}
                                                            centerMode={false}
                                                            className="thumb-slider mt-2"
                                                        >
                                                            {images.map((imageValue, index) => {
                                                                return (
                                                                    <div key={index} className="carousel-thumb-item">
                                                                        <LazyImage
                                                                            src={imageValue}
                                                                            alt={"room thumbnail"}
                                                                            loaderImage={require("../../../../Utility/Public/images/no-icon1.png")}
                                                                            className="carouselThumbpic"
                                                                        />
                                                                    </div>
                                                                );
                                                            })}
                                                        </Slider>
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                        {Object.keys(props.selected_branch.branch_full_details || {}).length > 0 && props.selected_branch.branch_full_details.hasOwnProperty('google_location') && props.selected_branch.branch_full_details.google_location != "" && props.selected_branch.branch_full_details.google_location != null &&
                                            <div className='col-md-3'>
                                                <div className='staticmap-container'>
                                                    <img src={require('../../../../Utility/Public/images/staticmap.png')} className="staticmap" />
                                                    <div className='staticmap-buttons'>
                                                        <p>
                                                            <i className="fa fa-map-marker" aria-hidden="true"></i>
                                                        </p>
                                                        <button onClick={() => showBranchMapFn(props.selected_branch.branch_full_details.google_location)}>Show on map</button>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className='col-md-12'>
                                    <div className='row'>
                                        <div className='branch-amenities-container'>
                                            <h6>Most popular facilities
                                                {Object.keys(props.selected_branch).length > 0 && isMobileView &&
                                                    Array.isArray(props.selected_branch?.branch_wise_amenity) &&
                                                    props.selected_branch.branch_wise_amenity.length > 0 ? (
                                                    <span className='room-facilities-info'
                                                        onClick={() => branchFacilitiesDetailsFn()}
                                                    ><i className="fa fa-info-circle" aria-hidden="true"></i></span>
                                                ) : null
                                                }
                                            </h6>
                                            {Object.keys(props.selected_branch).length > 0 && !isMobileView &&
                                                Array.isArray(props.selected_branch?.branch_wise_amenity) &&
                                                props.selected_branch.branch_wise_amenity.length > 0 ? (
                                                branchWiseAmenityUi()
                                            ) : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mobRevart'>
                                <div className='hotel-name'>
                                    <h3>Availability for {calculatedNights} {calculatedNights == 1 ? "Night" : "Nights"} {calculatedDays} Days, Stay for {props.userSearchDataFromReducer.adult} {Number(props.userSearchDataFromReducer.adult) > 1 ? "Adults" : "Adult"}{Number(props.userSearchDataFromReducer.children) > 0 ? `, ${Number(props.userSearchDataFromReducer.children)} ${Number(props.userSearchDataFromReducer.children) > 1 ? 'Children' : "child"}` : ``}</h3>
                                </div>
                                {isMobileView ?
                                    <div className='price-details-box price-details-box-mobile-view'>
                                        <div className="co-md-12 bookingProceedRightPanel">
                                            <div className='detailsLeftPanel'>
                                                <div className={showFull ? 'inndetailsLeftPanel mobileView' : 'inndetailsLeftPanel desktopView'}>
                                                    <div className='bookingCancelationSection bookingProceedSec yourBookingdetailsBox'>
                                                        <div className='innbookingProceedSec'>
                                                            <div className="descriptionSection bookingProceedSecBox">
                                                                <h6>Enquiry Details</h6>
                                                                <ul>
                                                                    <li>
                                                                        <p><em>Check-in</em><strong>{moment(props.userSearchDataFromReducer.start_date).format('ddd DD MMM YYYY')}</strong><span>{props.selected_branch.hasOwnProperty("branch_wise_booking_rule") && props.selected_branch.branch_wise_booking_rule && props.selected_branch.branch_wise_booking_rule.hasOwnProperty('checkin_time') && props.selected_branch.branch_wise_booking_rule.checkin_time != null ? formatTime(props.selected_branch.branch_wise_booking_rule.checkin_time) : ""}</span></p>
                                                                    </li>
                                                                    <li>
                                                                        <p><em>Check-out</em><strong>{moment(props.userSearchDataFromReducer.end_date).format('ddd DD MMM YYYY')}</strong><span>{props.selected_branch.hasOwnProperty("branch_wise_booking_rule") && props.selected_branch.branch_wise_booking_rule && props.selected_branch.branch_wise_booking_rule.hasOwnProperty('checkout_time') && props.selected_branch.branch_wise_booking_rule.checkout_time != null ? formatTime(props.selected_branch.branch_wise_booking_rule.checkout_time) : ""}</span></p>
                                                                    </li>
                                                                </ul>
                                                                <p className='bookingDetailsInnBox'>Total length of stay : <strong>{calculatedNights} {calculatedNights == 1 ? "Night" : "Nights"} {calculatedDays} Days</strong></p>
                                                                <div className='selectedBox'>
                                                                    <h5>You Selected :</h5>
                                                                    <p>
                                                                        <strong>
                                                                            {totalRooms} {totalRooms > 1 ? "Rooms" : "Room"} for{" "}
                                                                            {totalAdults} {totalAdults > 1 ? "Adults" : "Adult"}
                                                                            {totalChildren > 0 ? `, ${totalChildren} ${totalChildren > 1 ? 'Children' : "Child"}` : ``}
                                                                        </strong>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {totalRooms > 0 &&
                                                        <div className='bookingCancelationSection bookingProceedSec'>
                                                            <DetailsLeftPanel
                                                                selectedRoom={totalRooms > 0 ? props.userSearchDataFromReducer.selectedRoom : {}}
                                                                start_date={props.userSearchDataFromReducer.start_date}
                                                                end_date={props.userSearchDataFromReducer.end_date}
                                                            />
                                                            <div className='proceedBtnBoxes'>
                                                                <button className='proceedBtn' onClick={() => openHotelBookingModalFn()}> Get a Quote</button>
                                                            </div>
                                                        </div>}
                                                </div>
                                                {totalRooms > 0 &&
                                                    <div className='bookingCancelationSection bookingProceedSec forMobile'>
                                                        <div className='proceedBtnBoxes'>
                                                            <button className='detailsBtn' onClick={() => toggleShowFull("mob")}>{showFull ? 'Hide Details' : 'Show Details'}</button>
                                                            <div className={Object.keys(props.userCredentials).length == 0 ? 'innproceedBtnBoxes' : 'innproceedBtnBoxes singleBox'}>
                                                                <button className='proceedBtn' onClick={() => openHotelBookingModalFn()}> Get a Quote</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {totalRooms === 0 &&
                                                    <div className="bookingCancelationSection bookingProceedSec noSelect">
                                                        <div className="innbookingProceedSec"><div className="descriptionSection bookingProceedSecBox">
                                                            <h6>Room Type</h6>
                                                            <ul>
                                                                <li><span>{Utility.getCurrencySymbol(props.selected_branch?.currency)} 0/Room X 0 Room</span> <span>0/-</span></li>
                                                            </ul>
                                                        </div>
                                                        </div>
                                                        <div className='proceedBtnBoxes'>
                                                            <button className="proceedBtn disabled" disabled={true}>Get a Quote</button>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div> : null}
                                {/* {!isMobileView ?
                                    <div className='variant-wise-details-container-outer header-container-box'>
                                        <div className='variant-wise-details-container'>
                                            <div className='room-type-box'>Room type</div>
                                            <div className='room-type-variant-box'>
                                                <div className='number-of-guests-box'> Number of guests </div>
                                                <div className='today-price-box'>Today's price </div>
                                                <div className='variant-box'>Your options</div>
                                                <div className='select-room-box'> Select rooms </div>
                                            </div>
                                            <div className='price-details-box'></div>
                                        </div>
                                    </div> : null} */}
                                <div className={`variant-wise-details-container-outer content-container-box ${isMobileView ? "variant-wise-details-container-mobile-view" : ""}`}>
                                    <div className='variant-wise-details-container'>
                                        {roomTypeUi()}
                                    </div>
                                    {!isMobileView ?
                                        <div className='price-details-box'>
                                            <div className="co-md-12 bookingProceedRightPanel">
                                                <div className='detailsLeftPanel'>
                                                    <div className={showFull ? 'inndetailsLeftPanel mobileView' : 'inndetailsLeftPanel desktopView'}>
                                                        <div className='bookingCancelationSection bookingProceedSec yourBookingdetailsBox'>
                                                            <div className='innbookingProceedSec'>
                                                                <div className="descriptionSection bookingProceedSecBox">
                                                                    <h6>Enquiry Details</h6>
                                                                    <ul>
                                                                        <li>
                                                                            <p><em>Check-in</em><strong>{moment(props.userSearchDataFromReducer.start_date).format('ddd DD MMM YYYY')}</strong><span>{props.selected_branch.hasOwnProperty("branch_wise_booking_rule") && props.selected_branch.branch_wise_booking_rule && props.selected_branch.branch_wise_booking_rule.hasOwnProperty('checkin_time') && props.selected_branch.branch_wise_booking_rule.checkin_time != null ? formatTime(props.selected_branch.branch_wise_booking_rule.checkin_time) : ""}</span></p>
                                                                        </li>
                                                                        <li>
                                                                            <p><em>Check-out</em><strong>{moment(props.userSearchDataFromReducer.end_date).format('ddd DD MMM YYYY')}</strong><span>{props.selected_branch.hasOwnProperty("branch_wise_booking_rule") && props.selected_branch.branch_wise_booking_rule && props.selected_branch.branch_wise_booking_rule.hasOwnProperty('checkout_time') && props.selected_branch.branch_wise_booking_rule.checkout_time != null ? formatTime(props.selected_branch.branch_wise_booking_rule.checkout_time) : ""}</span></p>
                                                                        </li>
                                                                    </ul>
                                                                    <p className='bookingDetailsInnBox'>Total length of stay : <strong>{calculatedNights} {calculatedNights == 1 ? "Night" : "Nights"} {calculatedDays} Days</strong></p>
                                                                    <div className='selectedBox'>
                                                                        <h5>You Selected :</h5>
                                                                        <p>
                                                                            <strong>
                                                                                {totalRooms} {totalRooms > 1 ? "Rooms" : "Room"} for{" "}
                                                                                {totalAdults} {totalAdults > 1 ? "Adults" : "Adult"}
                                                                                {totalChildren > 0 ? `, ${totalChildren} ${totalChildren > 1 ? 'Children' : "Child"}` : ``}
                                                                            </strong>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {totalRooms > 0 &&
                                                            <div className='bookingCancelationSection bookingProceedSec'>
                                                                <DetailsLeftPanel
                                                                    selectedRoom={totalRooms > 0 ? props.userSearchDataFromReducer.selectedRoom : {}}
                                                                    start_date={props.userSearchDataFromReducer.start_date}
                                                                    end_date={props.userSearchDataFromReducer.end_date}
                                                                />
                                                                <div className='proceedBtnBoxes'>

                                                                    <button className='proceedBtn' onClick={() => openHotelBookingModalFn()}>Get a Quote
                                                                    </button>
                                                                </div>
                                                            </div>}
                                                    </div>
                                                    {totalRooms > 0 &&
                                                        <div className='bookingCancelationSection bookingProceedSec forMobile'>
                                                            <div className='proceedBtnBoxes'>
                                                                <button className='detailsBtn' onClick={() => toggleShowFull("mob")}>{showFull ? 'Hide Details' : 'Show Details'}</button>
                                                                <div className={Object.keys(props.userCredentials).length == 0 ? 'innproceedBtnBoxes' : 'innproceedBtnBoxes singleBox'}>
                                                                    <button className='proceedBtn' onClick={() => openHotelBookingModalFn()}> Get a Quote</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    {totalRooms === 0 &&
                                                        <div className="bookingCancelationSection bookingProceedSec noSelect">
                                                            <div className="innbookingProceedSec"><div className="descriptionSection bookingProceedSecBox">
                                                                <h6>Room Type</h6>
                                                                <ul>
                                                                    <li><span>{Utility.getCurrencySymbol(props.selected_branch?.currency)} 0/Room X 0 Room</span> <span>0/-</span></li>
                                                                </ul>
                                                            </div>
                                                            </div>
                                                            <div className='proceedBtnBoxes'>
                                                                <button className="proceedBtn disabled" disabled={true}>Get a Quote</button>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div> : null}
                                </div>



                                <div className="col-xl-9 col-md-8 col-sm-12">
                                    {/* <div className='hotel-name'>
                                    <h3>Availability for {calculatedNights} {calculatedNights == 1 ? "Night" : "Nights"} {calculatedDays} Days, Stay for {props.userSearchDataFromReducer.adult} {Number(props.userSearchDataFromReducer.adult) > 1 ? "Adults" : "Adult"}{Number(props.userSearchDataFromReducer.children) > 0 ? `, ${Number(props.userSearchDataFromReducer.children)} ${Number(props.userSearchDataFromReducer.children) > 1 ? 'Children' : "child"}` : ``}</h3>
                                </div> */}
                                    {/* <div className='detailsRightPanel hotelDetails'>
                                    {roomTypeUi()}
                                </div> */}
                                </div>
                                {/* <div className="col-xl-3 col-md-4 col-sm-12 bookingProceedRightPanel">
                                <div className='detailsLeftPanel'>
                                    <div className={showFull ? 'inndetailsLeftPanel mobileView' : 'inndetailsLeftPanel desktopView'}>
                                        <div className='bookingCancelationSection bookingProceedSec yourBookingdetailsBox'>
                                            <div className='innbookingProceedSec'>
                                                <div className="descriptionSection bookingProceedSecBox">
                                                    <h6>Your Booking Details</h6>
                                                    <ul>
                                                        <li>
                                                            <p><em>Check-in</em><strong>{moment(props.userSearchDataFromReducer.start_date).format('ddd DD MMM YYYY')}</strong><span>{props.selected_branch.hasOwnProperty("branch_wise_booking_rule") && props.selected_branch.branch_wise_booking_rule && props.selected_branch.branch_wise_booking_rule.hasOwnProperty('checkin_time') && props.selected_branch.branch_wise_booking_rule.checkin_time != null ? formatTime(props.selected_branch.branch_wise_booking_rule.checkin_time) : ""}</span></p>
                                                        </li>
                                                        <li>
                                                            <p><em>Check-out</em><strong>{moment(props.userSearchDataFromReducer.end_date).format('ddd DD MMM YYYY')}</strong><span>{props.selected_branch.hasOwnProperty("branch_wise_booking_rule") && props.selected_branch.branch_wise_booking_rule && props.selected_branch.branch_wise_booking_rule.hasOwnProperty('checkout_time') && props.selected_branch.branch_wise_booking_rule.checkout_time != null ? formatTime(props.selected_branch.branch_wise_booking_rule.checkout_time) : ""}</span></p>
                                                        </li>
                                                    </ul>
                                                    <p className='bookingDetailsInnBox'>Total length of stay : <strong>{calculatedNights} {calculatedNights == 1 ? "Night" : "Nights"} {calculatedDays} Days</strong></p>
                                                    <div className='selectedBox'>
                                                        <h5>You Selected :</h5>
                                                        <p>
                                                            <strong>
                                                                {totalRooms} {totalRooms > 1 ? "Rooms" : "Room"} for{" "}
                                                                {totalAdults} {totalAdults > 1 ? "Adults" : "Adult"}
                                                                {totalChildren > 0 ? `, ${totalChildren} ${totalChildren > 1 ? 'Children' : "Child"}` : ``}
                                                            </strong>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {totalRooms > 0 &&
                                            <div className='bookingCancelationSection bookingProceedSec'>
                                                <DetailsLeftPanel
                                                    selectedRoom={totalRooms > 0 ? props.userSearchDataFromReducer.selectedRoom : {}}
                                                    start_date={props.userSearchDataFromReducer.start_date}
                                                    end_date={props.userSearchDataFromReducer.end_date}
                                                />
                                                <div className='proceedBtnBoxes'>
                                                    {Object.keys(props.userCredentials).length == 0 &&
                                                        <button className='proceedBtn' onClick={() => openGuestCheckOutModalFn()}> Checkout as Guest</button>}
                                                    <button className='proceedBtn mtop5' onClick={() => openProceedPriceDistributionPage()}>{Object.keys(props.userCredentials).length == 0 ? "Checkout with login" : "Checkout"}</button>
                                                </div>
                                            </div>}
                                    </div>
                                    {totalRooms > 0 &&
                                        <div className='bookingCancelationSection bookingProceedSec forMobile'>
                                            <div className='proceedBtnBoxes'>
                                                <button className='detailsBtn' onClick={() => toggleShowFull("mob")}>{showFull ? 'Hide Details' : 'Show Details'}</button>
                                                <div className={Object.keys(props.userCredentials).length == 0 ? 'innproceedBtnBoxes' : 'innproceedBtnBoxes singleBox'}>
                                                    {Object.keys(props.userCredentials).length == 0 &&
                                                        <button className='proceedBtn' onClick={() => openGuestCheckOutModalFn()}> Checkout as Guest</button>}
                                                    <button className='proceedBtn mtop5' onClick={() => openProceedPriceDistributionPage()}>{Object.keys(props.userCredentials).length == 0 ? "Checkout with login" : "Checkout"}</button>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {totalRooms === 0 &&
                                        <div className="bookingCancelationSection bookingProceedSec noSelect">
                                            <div className="innbookingProceedSec"><div className="descriptionSection bookingProceedSecBox">
                                                <h6>Room Type</h6>
                                                <ul>
                                                    <li><span>{Utility.getCurrencySymbol(props.selected_branch?.currency)} 0/Room X 0 Room</span> <span>0/-</span></li>
                                                </ul>
                                            </div>
                                            </div>
                                            <div className='proceedBtnBoxes'>
                                                <button className="proceedBtn disabled" disabled={true}>{Object.keys(props.userCredentials).length == 0 ? "Checkout with login" : "Checkout"}</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showPaymentModal ? <PartialPaymentModal bookingDetails={userDetailsData} closePaymentModal={closePaymentModal} /> : ""
                }
                <ModalGlobal
                    show={fancyBoxModal}
                    onHide={closefancyBoxModal}
                    title=""
                    className="modalcustomize fancyBoxModal"
                    footer={false}
                    closeButton={true}
                    saveShow={false}
                    cancelShow={true}
                    cancelButtonLabel="Cancel"
                    cancelButtonClassName="cancel-btn"
                    onCancel={closefancyBoxModal}
                    body={
                        <>
                            <FancyBoxImage
                                fancyBoxSelectedImg={fancyBoxSelectedImg}
                                fancyimageList={fancyimageList}
                                setFancyBoxSelectedImg={setFancyBoxSelectedImg}
                            />
                        </>
                    }
                />

                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={paymentDetailsModalFlag}
                        onHide={closePaymentDetailsModalFn}
                        title="Payment Details"
                        className="modalcustomize mondimension paymentModal paymentModal paymentModalDialog paymentModalLargeSize"
                        footer={false}
                        closeButton={true}
                        saveButtonLabel="Payment"
                        saveButtonClassName="btn btn-primary savebtn modbtn"
                        cancelShow={true}
                        cancelButtonLabel={"Next Step"}
                        cancelButtonClassName="modbtn cancelbtn"
                        footerClassName="text-center topspace"
                        minimizeModal={false}
                        maximizeModal={true}
                        body={
                            <>
                                <ErrorBoundary title="BranchAddEditModalContent Error">
                                    <PaymentDetailsModalContent
                                        roomBookFormData={roomBookFormData}
                                        paymentDetailsData={paymentDetailsData}
                                        closePaymentDetailsModalFn={closePaymentDetailsModalFn}
                                        hotelRoomBookDataSet={hotelRoomBookDataSet}
                                        guestDetailsData={guestDetailsData}
                                        isGuestFlag={isGuestFlag}
                                        isLoggedIn={props.isLoggedIn}

                                        adult={totalAdults}
                                        child={totalChildren}
                                        child_age={props.userSearchDataFromReducer.children_age}
                                        child_age_limit={props.selected_branch.hasOwnProperty('branch_full_details') && Object.keys(props.selected_branch.branch_full_details).length > 0 && props.selected_branch.branch_full_details.hasOwnProperty('child_age_limit') && props.selected_branch.branch_full_details.child_age_limit != "" ? props.selected_branch.branch_full_details.child_age_limit : 9}
                                        nationality={props.selected_branch.hasOwnProperty('branch_full_details') && Object.keys(props.selected_branch.branch_full_details).length > 0 && props.selected_branch.branch_full_details.hasOwnProperty('country') && props.selected_branch.branch_full_details.country != "" ? props.selected_branch.branch_full_details.country : 'india'}
                                    />
                                </ErrorBoundary>
                            </>
                        }
                    />
                </ErrorBoundary>
                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={guestCheckOutModalFlag}
                        onHide={closeGuestCheckOutModalFn}
                        title="Guest Details"
                        className="modalcustomize mondimension guestDetailsModal"
                        footer={false}
                        closeButton={true}
                        saveButtonLabel="Payment"
                        saveButtonClassName="btn btn-primary savebtn modbtn"
                        cancelShow={true}
                        cancelButtonClassName="modbtn cancelbtn"
                        footerClassName="text-center topspace"
                        minimizeModal={false}
                        maximizeModal={true}
                        body={
                            <>
                                <ErrorBoundary title="BranchAddEditModalContent Error">
                                    <GuestCheckOutModalContent
                                        callBackToHotelDetails={callBackToHotelDetails}

                                    />
                                </ErrorBoundary>
                            </>
                        }
                    />
                </ErrorBoundary>
                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={hotelBookingModalFlag}
                        onHide={closeHotelBookingModalFn}
                        title="Customer details"
                        className="modalcustomize mondimension enqModalDetail"
                        footer={false}
                        closeButton={true}
                        cancelShow={true}
                        cancelButtonClassName="modbtn cancelbtn"
                        footerClassName="text-center topspace"
                        minimizeModal={false}
                        maximizeModal={true}
                        body={
                            <>
                                <ErrorBoundary title="HotelBooking Error">
                                    <HotelBooking
                                        show={hotelBookingModalFlag}
                                        onHide={closeHotelBookingModalFn}
                                        selectedRoom={selectedRoom}
                                        selected_branch={props.selected_branch}
                                        userSearchDataFromReducer={props.userSearchDataFromReducer}
                                        onBookingSuccess={clearSelectedRoomFn}
                                    />
                                </ErrorBoundary>
                            </>
                        }
                    />
                </ErrorBoundary>
                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={roomTypeDetailsModalFlag}
                        onHide={closeRoomTypeDetailsModal}
                        title="Room Type Details"
                        className="modalcustomize mondimension customerReviewModal room-type-details-dialog"
                        footer={false}
                        closeButton={true}
                        saveShow={false}
                        cancelShow={true}
                        cancelButtonLabel="Cancel"
                        cancelButtonClassName="cancel-btn"
                        body={
                            <>
                                <ErrorBoundary title="PartialPaymentModal Error">
                                    <RoomTypeDetailsModalContent
                                        closeRoomTypeDetailsModal={closeRoomTypeDetailsModal}
                                        roomTypeDetailsData={roomTypeDetailsData}
                                        exploreSlideOption={exploreSlideOption}
                                    />
                                </ErrorBoundary>
                            </>
                        }
                    />
                </ErrorBoundary>
                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={branchLocationModalFlag}
                        onHide={closeBranchMapFn}
                        title="Branch Location"
                        className="modalcustomize mondimension customerReviewModal branch-location-dialog"
                        footer={false}
                        closeButton={true}
                        saveShow={false}
                        cancelShow={true}
                        headerShow={false}
                        cancelButtonLabel="Cancel"
                        cancelButtonClassName="cancel-btn"
                        body={
                            <div className='branch-location-dialog-box'>
                                <ErrorBoundary title="Branch Location Modal Error">
                                    <div className='branch-location-box'>
                                        <button
                                            className='close-btn'
                                            onClick={closeBranchMapFn}
                                        >X</button>
                                        <div className='map-box'
                                            dangerouslySetInnerHTML={{ __html: branchLocationData }}
                                        />
                                    </div>
                                </ErrorBoundary>
                            </div>
                        }
                    />
                </ErrorBoundary>
                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={roomFacilitiesPopupDialogFlag}
                        onHide={roomFacilitiesDetailsCloseFn}
                        title="Room Facilities"
                        className="modalcustomize mondimension room-facilities-popup-dialog"
                        footer={false}
                        closeButton={true}
                        saveShow={false}
                        cancelShow={true}
                        cancelButtonLabel="Cancel"
                        cancelButtonClassName="cancel-btn"
                        body={
                            <>
                                <ErrorBoundary title="PartialPaymentModal Error">
                                    <div className='room-facilities-popup-container'>
                                        <ul>
                                            {roomFacilitiesPopupData.map((value, i) => (
                                                <li key={i}>
                                                    <span>
                                                        <LazyImage
                                                            src={value?.RoomTypeFacilityRelationData?.logo_url && value?.RoomTypeFacilityRelationData?.logo_url != "" ? JSON.parse(value?.RoomTypeFacilityRelationData?.logo_url).img_url : require('../../../../Utility/Public/images/no-icon1.png')}
                                                            alt={require('../../../../Utility/Public/images/no-icon1.png')}
                                                            loaderImage={require('../../../../Utility/Public/images/no-icon1.png')}
                                                            className={"facilityIcon"}
                                                        />
                                                        {value?.RoomTypeFacilityRelationData?.facility_name}
                                                    </span>
                                                </li>))}</ul>
                                    </div>
                                </ErrorBoundary>
                            </>
                        }
                    />
                </ErrorBoundary>
                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={branchFacilitiesPopupDialogFlag}
                        onHide={branchFacilitiesDetailsCloseFn}
                        title="Most popular facilities"
                        className="modalcustomize mondimension room-facilities-popup-dialog branch-facilities-popup-dialog"
                        footer={false}
                        closeButton={true}
                        saveShow={false}
                        cancelShow={true}
                        cancelButtonLabel="Cancel"
                        cancelButtonClassName="cancel-btn"
                        body={
                            <>
                                <ErrorBoundary title="PartialPaymentModal Error">
                                    <div className='room-facilities-popup-container'>
                                        {branchWiseAmenityUi()}
                                    </div>
                                </ErrorBoundary>
                            </>
                        }
                    />
                </ErrorBoundary>
            </div >
        </div>
    )
}

//total booking details ui panel
/*const DetailsLeftPanel = (props) => {
    let selectedRoom = props.selectedRoom;
    let startDate = props.start_date;
    let endDate = props.end_date;
    return Object.keys(selectedRoom).length > 0 && Object.keys(selectedRoom).map((key) => (
        <div className='innbookingProceedSec'>
            <div className='descriptionSection bookingProceedSecBox'>
                <h6>{selectedRoom[key].room_type_name}</h6>
                <ul>
                    <li>
                        <span>{Utility.getCurrencySymbol(selectedRoom[key].currency)} {selectedRoom[key].price_today}/Room X {selectedRoom[key].value} {selectedRoom[key].value > 1 ? "Rooms" : "Room"}</span>
                        <span>{Number(selectedRoom[key].total_room_price)}/-</span>
                    </li>
                </ul>
            </div>
        </div>
    ))
};*/
const DetailsLeftPanel = (props) => {
    let selectedRoom = props.selectedRoom;
    let startDate = props.start_date;
    let endDate = props.end_date;

    return Object.keys(selectedRoom).length > 0 &&
        Object.keys(selectedRoom).map((roomTypeId) =>
            Object.keys(selectedRoom[roomTypeId]).map((variantId, idx) => {
                const roomData = selectedRoom[roomTypeId][variantId];
                // console.log("roomData========", roomData)
                return (
                    <div className='innbookingProceedSec' key={`${roomTypeId}_${variantId}_${idx}`}>
                        <div className='descriptionSection bookingProceedSecBox'>
                            <h6>
                                {roomData.room_type_name}{" "}
                                {roomData.variant_code && (
                                    <span style={{ fontWeight: 400 }}>
                                        ({roomData.variant_code})
                                    </span>
                                )}
                            </h6>
                            <ul>
                                <li>
                                    <span>
                                        {Utility.getCurrencySymbol(roomData.currency)} {roomData.price_today}/Room X {roomData.value} {roomData.value > 1 ? "Rooms" : "Room"}
                                    </span>
                                    <span>{Number(roomData.total_room_price)}/-</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                );
            })
        );
};

HotelDetails.defaultProps = {
    selected_branch: {},
    userSearchDataFromReducer: {}
}



const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        selected_branch: globalState.mainReducerData.selected_branch,
        userSearchDataFromReducer: globalState.mainReducerData.userSearchData,
        priceDistributionRequestData: globalState.mainReducerData.priceDistributionRequestData,
        priceDistributionResponseData: globalState.mainReducerData.priceDistributionResponseData,
        trendingDestinationData: globalState.mainReducerData.trendingDestination
    };
}

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setUserCredentials, userSearchData, priceDistributionRequestData, priceDistributionResponseData, trendingDestination, selectChooseBranch })(withRouter(HotelDetails));